
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import DropdownOption from "@/entities/DropdownOption";
  import { Document_Bool_Exp, Query_RootIndustryArgs } from "@/generated/graphql";
  import DropdownFilter from "@/components/filters/DropdownFilter.vue";
  import GET_MULTISELECT_DOCUMENTS from "@/apollo/documents/GetMultiselectDocuments.gql";
  import filterMultiselectItems from "@/helpers/multiselect/filterMultiselectItems";
  import getProjectDropdownOptions from "@/helpers/multiselect/getProjectDropdownOptions";
  import MultiselectTag from "@/components/autocompleteMultiselects/MultiselectTag.vue";

  @Component({
    components: {
      MultiselectTag,
      DropdownFilter,
    },
    apollo: {
      documents: {
        query: GET_MULTISELECT_DOCUMENTS,
        variables() {
          return this.documentFilter;
        },
        update(data) {
          return data.document;
        },
        skip() {
          return !this.searchString;
        },
      },
    },
  })
  export default class DocumentMultiselect extends Vue {
    @Prop({ type: Array, required: true }) value!: string[];
    @Prop({ type: Number, default: 5 }) limit!: number;
    @Prop({ type: Object, default: () => ({}) }) readonly conditions!: Document_Bool_Exp;

    documents: Document[] = [];
    searchString: string = "";
    chosenDocuments: DropdownOption[] = [];

    get documentFilter(): Query_RootIndustryArgs {
      const conditions: any[] = [
        this.conditions,
        {
          filename: {
            _ilike: `%${this.searchString}%`,
          },
        },
      ];

      if (this.value.length) {
        conditions.push({
          id: {
            _nin: this.value,
          },
        });
      }

      return {
        where: { _and: conditions },
        limit: this.limit,
      };
    }

    @Watch('value', { immediate: true })
    async onProjectsIdsChanged(): Promise<void> {
      const documentIds = this.value;

      if (documentIds.length === 0) {
        this.chosenDocuments = [];
      }

      const {
        newItemsIds: newDocumentIds,
        previouslyChosenItems: previouslyChosenProjects,
      } = filterMultiselectItems<DropdownOption>(documentIds, this.chosenDocuments);

      if (newDocumentIds.length === 0) {
        return;
      }

      const rawData = await this.$apollo.query({
        query: GET_MULTISELECT_DOCUMENTS,
        variables: {
          where: {
            id: {
              _in: newDocumentIds,
            },
          },
        },
      })

      const newChosenDocuments = getProjectDropdownOptions(rawData.data.document);

      this.chosenDocuments = [...previouslyChosenProjects, ...newChosenDocuments];
    }

    handleInput(selectedOptions: DropdownOption[]): void {
      this.chosenDocuments = selectedOptions;
      const documentIds = selectedOptions.map(option => option.id);
      this.$emit("input", documentIds);
    }
  }
